/* tslint:disable */
/* eslint-disable */
/**
 * Profile API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ResponsivePicture
 */
export interface ResponsivePicture {
    /**
     * 
     * @type {string}
     * @memberof ResponsivePicture
     */
    highResolutionUrl: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsivePicture
     */
    mediumResolutionUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof ResponsivePicture
     */
    lowResolutionUrl?: string;
}

/**
 * Check if a given object implements the ResponsivePicture interface.
 */
export function instanceOfResponsivePicture(value: object): value is ResponsivePicture {
    if (!('highResolutionUrl' in value) || value['highResolutionUrl'] === undefined) return false;
    return true;
}

export function ResponsivePictureFromJSON(json: any): ResponsivePicture {
    return ResponsivePictureFromJSONTyped(json, false);
}

export function ResponsivePictureFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponsivePicture {
    if (json == null) {
        return json;
    }
    return {
        
        'highResolutionUrl': json['highResolutionUrl'],
        'mediumResolutionUrl': json['mediumResolutionUrl'] == null ? undefined : json['mediumResolutionUrl'],
        'lowResolutionUrl': json['lowResolutionUrl'] == null ? undefined : json['lowResolutionUrl'],
    };
}

export function ResponsivePictureToJSON(value?: ResponsivePicture | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'highResolutionUrl': value['highResolutionUrl'],
        'mediumResolutionUrl': value['mediumResolutionUrl'],
        'lowResolutionUrl': value['lowResolutionUrl'],
    };
}

